// src/pages/AdminLogin.jsx
import React, { useState } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';

export default function AdminLogin({ onLogin }) {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const cred = await signInWithEmailAndPassword(auth, email, password);
      onLogin(cred.user);
    } catch (err) {
      setError('Invalid email or password.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--sand-bg)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'Source Serif 4', serif",
    }}>
      <div style={{
        background: '#fff', border: '0.5px solid var(--sand-border)',
        borderRadius: 'var(--radius-lg)', padding: '36px 40px',
        width: '100%', maxWidth: 380,
      }}>
        {/* Logo */}
        <div style={{ marginBottom: 28, textAlign: 'center' }}>
          <div style={{
            fontFamily: "'Playfair Display', serif", fontSize: 22,
            fontWeight: 700, color: 'var(--sand-text)',
          }}>
            Comfy<span style={{ color: 'var(--sand-amber)' }}>Stack</span>
          </div>
          <div style={{
            fontFamily: "'JetBrains Mono', monospace", fontSize: 10,
            color: 'var(--sand-hint)', letterSpacing: 2, marginTop: 4,
          }}>ADMIN</div>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div>
            <label style={{ fontSize: 12, color: 'var(--sand-muted)', display: 'block', marginBottom: 5 }}>
              Email
            </label>
            <input
              type="email" value={email} onChange={e => setEmail(e.target.value)}
              required autoFocus
              style={{
                width: '100%', padding: '9px 12px',
                border: '0.5px solid var(--sand-border)', borderRadius: 'var(--radius-sm)',
                fontSize: 13, fontFamily: "'Source Serif 4', serif",
                background: 'var(--sand-bg)', color: 'var(--sand-text)',
                outline: 'none',
              }}
            />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--sand-muted)', display: 'block', marginBottom: 5 }}>
              Password
            </label>
            <input
              type="password" value={password} onChange={e => setPassword(e.target.value)}
              required
              style={{
                width: '100%', padding: '9px 12px',
                border: '0.5px solid var(--sand-border)', borderRadius: 'var(--radius-sm)',
                fontSize: 13, fontFamily: "'Source Serif 4', serif",
                background: 'var(--sand-bg)', color: 'var(--sand-text)',
                outline: 'none',
              }}
            />
          </div>

          {error && (
            <p style={{
              fontSize: 12, color: '#a32d2d',
              background: '#fcebeb', border: '0.5px solid #f09595',
              borderRadius: 'var(--radius-sm)', padding: '7px 11px',
            }}>{error}</p>
          )}

          <button
            type="submit" disabled={loading}
            style={{
              marginTop: 4, padding: '10px',
              background: loading ? 'var(--sand-border)' : 'var(--sand-amber)',
              color: '#fff', border: 'none',
              borderRadius: 'var(--radius-sm)', fontSize: 13,
              fontFamily: "'Source Serif 4', serif",
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'background 0.15s',
            }}
          >
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
